import { type default as JobGetApiJson } from "entity/job/Job/json/Job.get.api.json";

import { type default as OnlinePaymentLimitsApiJson } from "./OnlinePaymentLimits.api.json";

export const FeeComplianceDisclaimerContent =
    "Ensure compliance with applicable laws and card network rules before passing credit card fees on to your clients";

export const ACHFeeComplianceDisclaimerContent =
    "Ensure compliance with applicable laws before passing processing fees on to your clients";

export const ACHFeeExplanationContent =
    "Our standard ACH rate is $15 which is being passed to clients. If you decide not to pass through costs, your existing pricing will be in effect";

export type OnlinePaymentLimitsApiData =
    | typeof OnlinePaymentLimitsApiJson
    | (typeof JobGetApiJson)["ownerInfo"];

export interface IOnlinePaymentLimitsFormValues {
    allowPartialPayments: boolean;
    allowCreditCards: boolean;
    minCreditCard: number | null;
    maxCreditCard: number | null;
    allowChecks: boolean;
    minCheck: number | null;
    maxCheck: number | null;
    passCreditCardFeesToOwner: boolean;
    passACHFeesToClient: boolean;
}

export class OnlinePaymentLimitsEntity {
    constructor(data: OnlinePaymentLimitsApiData) {
        this.allowPartialPayments =
            typeof data.allowPartialPayments === "boolean"
                ? data.allowPartialPayments
                : (data.allowPartialPayments?.value ?? false);
        this.allowCreditCards = data.allowCreditCards;
        this.allowChecks = data.allowChecks;
        this.canAcceptChecks = data.canAcceptChecks;
        this.creditCardFloor = data.creditCardFloor;
        this.minCreditCard = data.minCreditCard ?? this.creditCardFloor;
        this.maxCreditCard =
            data.maxCreditCard !== undefined && data.maxCreditCard !== 0
                ? data.maxCreditCard
                : null;
        this.creditCardTransactionLimit = data.creditCardTransactionLimit;
        this.checkFloor = data.checkFloor;
        this.minCheck = data.minCheck ?? this.checkFloor;
        this.maxCheck = data.maxCheck !== undefined && data.maxCheck !== 0 ? data.maxCheck : null;
        this.bankTransactionLimit = data.bankTransactionLimit;
        this.passCreditCardFeesToOwner = data.passCreditCardFeesToOwner;
        this.passACHFeesToClient = data.passACHFeesToClient;
    }

    allowPartialPayments: boolean;
    allowCreditCards: boolean;
    canAcceptChecks: boolean;
    minCreditCard: number | null;
    maxCreditCard: number | null;
    allowChecks: boolean;
    minCheck: number | null;
    maxCheck: number | null;
    creditCardFloor: number;
    creditCardTransactionLimit: number;
    checkFloor: number;
    bankTransactionLimit: number;
    passCreditCardFeesToOwner: boolean;
    passACHFeesToClient: boolean;
}

export class UpdateExistingJobsResponse {}
